import { makeStyles } from '@material-ui/core';

export const useDetailStyles = makeStyles(() => ({
    radioWrapper: {
        margin: '8px 0',

        '& .MuiFormControlLabel-root': {
            marginTop: 0,
        },
    },
    testSelect: {
        marginRight: '8px',

        '& .MuiSelect-select': {
            minWidth: 390,
        },
    },
    selectionError: {
        color: '#BF3D56',
    },
}));
